import { render, staticRenderFns } from "./BusOrderConnection.vue?vue&type=template&id=03b86e7a&scoped=true"
import script from "./BusOrderConnection.vue?vue&type=script&lang=js"
export * from "./BusOrderConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b86e7a",
  null
  
)

export default component.exports